import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const Chat = ({ className = '' }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <svg className={className} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <title>Chat</title>
      <g fillRule="evenodd">
        <path
          fill={`${isTempo ? '#7FC1FB' : '#99CE99'}`}
          d="M7.5 8.75H4.5C3.39543 8.75 2.5 9.64543 2.5 10.75V20.5429C2.5 20.9883 3.03857 21.2114 3.35355 20.8964L5.5 18.75H14.5C15.6046 18.75 16.5 17.8546 16.5 16.75V13.75H9.5C8.39543 13.75 7.5 12.8546 7.5 11.75V8.75Z"
        />
        <path
          fill={`${isTempo ? '#2B2B2B' : '#004400'}`}
          d="M19.5 3.25C20.8807 3.25 22 4.36929 22 5.75V15.5429C22 16.4338 20.9229 16.88 20.2929 16.25L18.2929 14.25H17V16.75C17 18.1307 15.8807 19.25 14.5 19.25H5.70711L3.70711 21.25C3.07714 21.88 2 21.4338 2 20.5429V10.75C2 9.36929 3.11929 8.25 4.5 8.25H7V5.75C7 4.36929 8.11929 3.25 9.5 3.25H19.5ZM7 9.25H4.5C3.67157 9.25 3 9.92157 3 10.75V20.5429L5.14645 18.3964C5.24021 18.3027 5.36739 18.25 5.5 18.25H14.5C15.3284 18.25 16 17.5784 16 16.75V14.25H9.5C8.11929 14.25 7 13.1307 7 11.75V9.25ZM21 5.75C21 4.92157 20.3284 4.25 19.5 4.25H9.5C8.67157 4.25 8 4.92157 8 5.75V11.75C8 12.5784 8.67157 13.25 9.5 13.25H18.5C18.6326 13.25 18.7598 13.3027 18.8536 13.3964L21 15.5429V5.75ZM10.5 7.25C10.5 6.97386 10.7239 6.75 11 6.75H18.5C18.7761 6.75 19 6.97386 19 7.25C19 7.52614 18.7761 7.75 18.5 7.75H11C10.7239 7.75 10.5 7.52614 10.5 7.25ZM13 9.75C12.7239 9.75 12.5 9.97386 12.5 10.25C12.5 10.5261 12.7239 10.75 13 10.75H18.5C18.7761 10.75 19 10.5261 19 10.25C19 9.97386 18.7761 9.75 18.5 9.75H13Z"
        />
      </g>
    </svg>
  );
};

Chat.propTypes = {
  className: PropTypes.string,
};

export default Chat;
